{
  "maximum": "أقصى",
  "minimum": "أدنى"
}
